import { render, staticRenderFns } from "./AddNewCXC.vue?vue&type=template&id=b9381100&scoped=true&"
import script from "./AddNewCXC.vue?vue&type=script&lang=js&"
export * from "./AddNewCXC.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCXC.vue?vue&type=style&index=0&id=b9381100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9381100",
  null
  
)

export default component.exports